import { defaultHttpClient } from '../../httpClient';
import { type RegisterPocParams } from './types';

export const registerPoc = async (params: RegisterPocParams) => {
  return defaultHttpClient.request<void>({
    method: 'POST',
    url: `/api/v2/members/me/poc/`,
    data: params,
  });
};
